module.exports = __webpack_public_path__ + "static/Parents-729aa0514e2387a5b7501f82ccad9ca0.svg";